// import { useXXXModal } from '../new-modal';

import { useRef } from 'react';
import _ from 'lodash';
import { useSelectAddressModal } from '../screens/location/select-address-modal';
import { useNewAddressWorkflow } from './new-address-workflow';
import { useAddressDeleteModal } from '../screens/location/address-delete-modal';
import { useAddressDeletedModal } from '../screens/location/address-deleted-modal';

function useAddressWorkflow() {
  const { prepareSelectAddressModal, showSelectAddressModal } =
    useSelectAddressModal();
  const { clearNewAddressWorkflow, showNewAddressWorkflow } =
    useNewAddressWorkflow();
  const { showAddressdDeleteModal } = useAddressDeleteModal();
  const { showPaymentCardDeletedModal } = useAddressDeletedModal();

  const prepareResultRef = useRef();

  async function prepare() {
    const result = await prepareSelectAddressModal();
    await clearNewAddressWorkflow();

    prepareResultRef.current = result;
  }

  async function show({ prepareOnPreConfirm, avoidAnimation } = {}) {
    let repeat = false;
    let result = prepareResultRef.current;
    // const previousHasStreetNumber = null;

    // TODO: Implement this function

    /* eslint-disable no-await-in-loop */
    do {
      if (
        result.hasAddresses &&
        !result.wasStreetNumberBackButtonClicked &&
        !result.wasComplementBackButtonClicked &&
        !result.wasImcompleteBackButtonClicked
      ) {
        const showResult = await showSelectAddressModal({
          wasBackButtonClicked: result.isDismissed,
          avoidAnimation: avoidAnimation || result.wasDeleteAddressClicked,
          prepareOnPreConfirm,
        });

        result.wasNewAddressBackButtonClicked = false;
        result.wasDeleteAddressClicked = false;

        delete result.address;

        result = _.merge(result, showResult);
      }

      if (result.wasDeleteAddressClicked) {
        const showResult = await showAddressdDeleteModal({
          address: result.address,
          prepareOnPreConfirm: async () => {
            await prepare();
          },
        });

        result.address = null;
        result.hasAddresses = prepareResultRef.current.hasAddresses;

        result = _.merge(result, showResult);
      }

      if (result.wasDeleteAddressClicked && result.isConfirmed) {
        await showPaymentCardDeletedModal();
      }

      if (!result.hasAddresses || result.wasOtherAddressClicked) {
        // se result.wasDeleteAddressClicked então não deve fazer a animação.

        await clearNewAddressWorkflow();

        const showResult = await showNewAddressWorkflow({
          showBackButton: result.wasOtherAddressClicked,
          avoidAnimation: result.wasDeleteAddressClicked,
          prepareOnPreConfirm,
        });

        result.wasDeleteAddressClicked = false;
        result.wasNewAddressBackButtonClicked = false;

        delete result.address;

        result = _.merge(result, showResult);
      }

      repeat =
        result.wasNewAddressBackButtonClicked ||
        result.wasDeleteAddressClicked ||
        (result.wasDeleteAddressClicked && !result.isDenied) ||
        (result.wasOtherAddressClicked && result.isDenied);
    } while (repeat);

    console.log(result.address);

    return result;
  }

  return {
    prepareAddressWorkflow: prepare,
    showAddressWorkflow: show,
  };
}

export { useAddressWorkflow };
